const MONTH_NAMES: string[] = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

const getSuffix = (day: number) => {
  switch (day) {
    case 1:
    case 21:
    case 31:
      return 'st';
    case 2:
    case 22:
      return 'nd';
    case 3:
    case 23:
      return 'rd';
    default:
      return 'th';
  }
};

const getFormattedDate = (date: string, text?: string, hasYear = false) => {
  const d: Date = typeof date === 'object' ? date : new Date(date);

  const day = d.getDate();
  const month = MONTH_NAMES[d.getMonth()];
  const year = d.getFullYear();
  const hours = d.getHours();
  let minutes: any = d.getMinutes();

  // Adding leading zero to minutes
  if (minutes < 10) minutes = `0${minutes}`;

  // Today at 10:20
  // Yesterday at 10:20
  if (text) return `${text} at ${hours}:${minutes}`;

  // 10th Jan, 2022
  if (hasYear) return `${day}${getSuffix(day)} ${month}, ${year}`;

  // 10th Jan at 10:20
  return `${day}${getSuffix(day)} ${month} at ${hours}:${minutes}`;
};

// --- Main function
const formatDate = (date: string) => {
  if (!date) return null;

  const d: any = new Date(date);
  const DAY_IN_MS = 86400000; // 24 * 60 * 60 * 1000
  const today: any = new Date();
  const yesterday = new Date(today - DAY_IN_MS);
  const seconds = Math.round((today - d) / 1000);
  const minutes = Math.round(seconds / 60);
  const isToday = today.toDateString() === d.toDateString();
  const isYesterday = yesterday.toDateString() === d.toDateString();
  const isThisYear = today.getFullYear() === d.getFullYear();

  if (seconds < 5) return 'Just now';
  else if (seconds < 60) return `${seconds} seconds ago`;
  else if (seconds < 90) return 'about a minute ago';
  else if (minutes < 60) return `${minutes} minutes ago`;
  else if (isToday) return getFormattedDate(date, 'Today');
  else if (isYesterday) return getFormattedDate(date, 'Yesterday');
  else if (isThisYear) return getFormattedDate(date);
  return getFormattedDate(date, '', true);
};

export default formatDate;
